import React from "react";
import { Modal, ModalBody } from "reactstrap";
import GroupUpdateAvaiabilityStatus from "./GroupUpdateAvaiabilityStatus";
import GroupIcon from '@mui/icons-material/Group';
import { Typography, Box } from '@mui/material';

import PropTypes from 'prop-types';

const GroupUpdateAvaiabilityStatusModal = ({ open, setOpen, dataInfo }) => {
    const toggle = () => {
        setOpen(prevState => !prevState)
    }

    return (
        <Modal
            isOpen={open}
            toggle={toggle}
            className="theme-light ltr-support credit-memo-modal-form-ani"
            centered
            style={{ maxWidth: '800px' }}
        >
            <div className="modal__header border-bottom-0 pb-0">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={toggle}
                />
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <GroupIcon className="text-primary me-2" style={{ fontSize: '1.5rem' }} />
                    <Typography
                        variant="h6"
                        className="text-uppercase fw-bold m-0"
                        sx={{ color: '#32CA71', letterSpacing: '0.5px' }}
                    >
                        Bulk Availability Management
                    </Typography>
                </Box>
            </div>
            <ModalBody className="p-0">
                <div className="credit-memo-modal-form-ani p-1">
                    <GroupUpdateAvaiabilityStatus dataInfo={dataInfo} />
                </div>
            </ModalBody>
        </Modal>
    );
};

GroupUpdateAvaiabilityStatusModal.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    dataInfo: PropTypes.any
};

export default GroupUpdateAvaiabilityStatusModal;